import { Component } from '@theme/component';

const normalize = (text) => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

class SaniFaq extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.input = this.querySelector('[data-faq-search]');
    this.items = [...this.querySelectorAll('[data-faq-item]')];
    this.groups = [...this.querySelectorAll('[data-faq-group]')];
    this.savedOpen = null;
    this.querySelector('[data-faq-search-wrap]').hidden = false;
    this.input.addEventListener('input', () => this.filter(), options);
    this.querySelector('[data-faq-clear]').addEventListener('click', () => {
      this.input.value = '';
      this.filter();
      this.input.focus();
    }, options);
    this.addEventListener('click', (event) => {
      const link = event.target.closest?.('[data-faq-jump]');
      if (!link) return;
      this.input.value = '';
      this.filter();
    }, options);
    window.addEventListener('hashchange', () => this.revealHash(), options);
    document.addEventListener('click', (event) => {
      const link = event.target.closest?.('a[href^="#sani-faq"]');
      if (link && !link.closest('sani-assistant')) this.reveal();
    }, options);
    this.revealHash();
  }

  disconnectedCallback() {
    this.controller?.abort();
    super.disconnectedCallback();
  }

  filter() {
    const words = normalize(this.input.value).split(/\s+/).filter(Boolean);
    if (words.length && !this.savedOpen) this.savedOpen = new Map(this.items.map(item => [item, item.open]));
    let count = 0;
    for (const item of this.items) {
      const text = normalize(item.textContent);
      const match = words.every(word => text.includes(word));
      item.hidden = !match;
      if (words.length) item.open = match;
      else if (this.savedOpen) item.open = this.savedOpen.get(item) || false;
      if (match) count++;
    }
    this.groups.forEach(group => { group.hidden = ![...group.querySelectorAll('[data-faq-item]')].some(item => !item.hidden); });
    if (!words.length) this.savedOpen = null;
    this.querySelector('[data-faq-clear]').hidden = !words.length;
    this.querySelector('[data-faq-empty]').hidden = count > 0;
    this.querySelector('[data-faq-status]').textContent = words.length ? this.dataset.results.replace('__COUNT__', String(count)) : '';
  }

  reveal() {
    const disclosure = this.closest('[data-faq-disclosure]');
    if (disclosure) disclosure.open = true;
  }

  revealHash() {
    const hash = window.location.hash.slice(1);
    if (!hash) return;
    const target = document.getElementById(hash);
    if (!target || !(target === this || this.contains(target) || target === this.closest('[data-faq-disclosure]'))) return;
    this.reveal();
    if (target.matches('[data-faq-item]')) target.open = true;
  }
}

if (!customElements.get('sani-faq')) customElements.define('sani-faq', SaniFaq);
